import React from "react";
import { FiAlertCircle, FiArrowDownCircle, FiArrowRight, FiArrowUpCircle, FiBox, FiKey, FiMapPin, FiSearch } from "react-icons/fi";
import { EditableFieldTypes } from "../../../../components/editable/EditableField/EditableField";
import { IWorkflowToolBoxItem, IWorkflowDataSources } from "../../../../logic/api";
import { useTranslation } from "react-i18next";

export default () => {
    const toolBoxItems: IWorkflowToolBoxItem[] = [];
    const { t } = useTranslation();

    toolBoxItems.push({
        name: t("workflow.showMsg"),
        description: t("workflow.presentInstructionsUser"),
        ref: "message",
        compatChildRefs: ["*"],
        properties: [
            { name: "title", label: t("workflow.title"), defaultValue: "", type: EditableFieldTypes.text },
            { name: "message", label: t("workflow.message"), defaultValue: "", type: EditableFieldTypes.textMultiLine },
        ],
        visibleAsProcess: false,
    });

    toolBoxItems.push({
        name: t("workflow.vehicleMove"),
        description: t("workflow.requireUserToMoveVehicle"),
        ref: "vmovement",
        compatChildRefs: ["*"],
        properties: [
            { name: "locationType", label: t("workflow.vehicleLocationType"), defaultValue: null, type: EditableFieldTypes.terminalField, dataSource: IWorkflowDataSources.vehicle },
            { name: "location", label: t("workflow.location"), defaultValue: null, type: EditableFieldTypes.locationLane }
        ],
        /*properties: [
            { name: "zone", label: "Zone", defaultValue: null, type: EditableFieldTypes.dropDownField, dataSource: IWorkflowDataSources.zones },
            { name: "lane", label: "Lane", defaultValue: null, type: EditableFieldTypes.dropDownField, dataSource: IWorkflowDataSources.lanes },
        ],*/
        visibleAsProcess: true,
    });

    /* toolBoxItems.push({
         name: "Key Move",
         description: "Require the user to move the vehicle key",
         ref: "kmovement",
         compatChildRefs: ["*"],
         properties: [
             { name: "locationType", label: "Key Location Type", defaultValue: null, type: EditableFieldTypes.dropDownField, dataSource: IWorkflowDataSources.key },
             { name: "location", label: "Location", defaultValue: null, type: EditableFieldTypes.locationKeyroom }
 
         ],
         visibleAsProcess: true,
     });*/

    toolBoxItems.push({
        name: t("workflow.inspection"),
        ref: "inspection",
        description: t("workflow.reqInspection"),
        compatChildRefs: ["*"],
        properties: [
            { name: "mileage", label: t("workflow.captureMileage"), defaultValue: true, type: EditableFieldTypes.switch },
            { name: "fuel", label: t("workflow.captureFuel"), defaultValue: true, type: EditableFieldTypes.switch },
            { name: "minPhotos", label: t("workflow.minPhotos"), defaultValue: "1", type: EditableFieldTypes.number }
        ],
        visibleAsProcess: true,
    });

    toolBoxItems.push({
        name: t("workflow.nextVehicle"),
        description: t("workflow.scanNextVehicle"),
        ref: "next",
        compatChildRefs: ["*"],
        properties: [],
        visibleAsProcess: false,
    });

    toolBoxItems.push({
        name: t("workflow.checkout"),
        description: t("workflow.startCheckout"),
        ref: "checkout",
        compatChildRefs: ["next"],
        properties: [],
        visibleAsProcess: true,
    });

    toolBoxItems.push({
        name: t("workflow.checkin"),
        description: t("workflow.startCheckIn"),
        ref: "checkin",
        compatChildRefs: ["inspection", "vmovement", "kmovement", "message", "next"],
        properties: [],
        visibleAsProcess: true,
    });

    return toolBoxItems;
}

export const getToolBoxItemByRef = (toolBoxItems: IWorkflowToolBoxItem[], ref: string) => {
    return toolBoxItems.filter((tbi) => {
        return tbi.ref == ref;
    })[0]
}

export const getToolBoxIconByRef = (toolBoxItems: IWorkflowToolBoxItem[], ref: string, size: number, color?: string) => {
    if (ref == "message") {
        return <FiAlertCircle size={size} color={color}></FiAlertCircle>;
    }
    if (ref == "inspection") {
        return <FiSearch size={size} color={color}></FiSearch>;
    }
    if (ref == "vmovement") {
        return <FiMapPin size={size} color={color}></FiMapPin>;
    }
    if (ref == "kmovement") {
        return <FiKey size={size} color={color}></FiKey>;
    }
    if (ref == "next") {
        return <FiArrowRight size={size} color={color}></FiArrowRight>;
    }
    if (ref == "checkout") {
        return <FiArrowUpCircle size={size} color={color}></FiArrowUpCircle>;
    }
    if (ref == "checkin") {
        return <FiArrowDownCircle size={size} color={color}></FiArrowDownCircle>;
    }
    return <FiBox size={size}></FiBox>;
}